import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'
const equipRouter: RouteConfig = {
  path: '/injuryManage',
  redirect: 'noredirect',
  name: 'injuryManage',
  component: Layout,
  children: [
    {
      path: 'injuryManage',
      component: () => import('@/views/injuryManage/index.vue'),
      name: 'injuryManage',
      meta: {
        title: '伤情管理',
        icon: 'resource',
        requireAuth: true,
      }
    },
  ]

}

export default equipRouter
